import $ from "jquery";
import { u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
const { app } = window;

// [homeSection] VuwFade
// メインメニューを持つコンポーネント
!!vuwer.get("pageMain") && vuwer.add("homeSection", {
	vuwType: "fade",
	
	selector() {
		return $("<div/>").addClass("section vuw-fade").attr({
			"id": "home_section",
			"data-section": "home",
			"data-visible": "0"
		}).appendTo( vuwer.get("pageMain").$self );
	},
	
	onReady($self) {
		this.$content = $("<div/>").addClass("content").appendTo($self);
	},
	
	onChangeState(state) {
		const menu = state.menu;
		delete state.menu;
		
		if( u_.isObject(menu) ) {
			return this.get("menu.nav").setState("items", menu);
		}
	}
}, function() {
	// [add child Vuw]
	this
	// define [nav]
	.add("nav", {
		className: "nav-menu",
		
		selector() {
			return $("<nav/>").addClass(this.className).attr("data-items", 0)
			.appendTo(this.container.$content);
		},
		
		onReady($self) {
			// [add event listener]
			$self.on("click", ".toggle-menu", e => {
				$(e.currentTarget).toggleClass("is-active")
				.next(".sub-menu").slideToggle(200);
				return false;
			});
		}
	}, function() {
		// [add child Vuw]
		const { render} = app.nav.get("menu");
		
		this
		// [menu]
		.add("menu", {
			selector() {
				return $("<var/>").appendTo(this.container.$self);
			},
			
			createTemplate() {
				return app.nav.get("menu").$template;
			},
			
			render
		});
	});
});
